"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var lodash_1 = require("lodash");
function findLowestPrice(csp) {
    var inventory = csp.inventory;
    if (!inventory)
        return null;
    if (!inventory.usedLowPrice) {
        return inventory.newLowPrice;
    }
    if (!inventory.newLowPrice) {
        return inventory.usedLowPrice;
    }
    if (inventory.newLowPrice.amountCents < inventory.usedLowPrice.amountCents) {
        return inventory.newLowPrice;
    }
    return inventory.usedLowPrice;
}
exports.findLowestPrice = findLowestPrice;
function renderMeta(count, price) {
    if (!price) {
        return null;
    }
    return (React.createElement("span", { className: "d-none" },
        React.createElement("meta", { itemProp: "offerCount", content: String(count) }),
        React.createElement("meta", { itemProp: "priceCurrency", content: price.currency }),
        React.createElement("meta", { itemProp: "lowPrice", content: price.amount })));
}
function BrandMetaData(props) {
    var brand = lodash_1.get(props.csp, 'brand.name');
    if (!brand)
        return null;
    return (React.createElement("meta", { content: brand, itemType: "http://schema.org/Brand", itemProp: "brand" }));
}
exports.BrandMetaData = BrandMetaData;
function PriceMetaData(props) {
    var csp = props.csp, conditionFilter = props.conditionFilter;
    var inventory = csp.inventory;
    if (!inventory) {
        return null;
    }
    if (conditionFilter === 'new') {
        return renderMeta(inventory.newTotal, inventory.newLowPrice);
    }
    if (conditionFilter === 'used') {
        return renderMeta(inventory.usedTotal, inventory.usedLowPrice);
    }
    var total = inventory.usedTotal + inventory.newTotal;
    var lowestPrice = findLowestPrice(csp);
    return renderMeta(total, lowestPrice);
}
exports.PriceMetaData = PriceMetaData;
function NameMetaData(props) {
    var name = lodash_1.get(props.csp, 'title');
    if (!name)
        return null;
    return (React.createElement("meta", { content: name, itemProp: "name" }));
}
exports.NameMetaData = NameMetaData;
function DescriptionMetaData(props) {
    var description = lodash_1.get(props.csp, 'metaDescription');
    if (!description)
        return null;
    return (React.createElement("meta", { content: description, itemProp: "description" }));
}
exports.DescriptionMetaData = DescriptionMetaData;
function ImageMetaData(props) {
    var image = lodash_1.get(props.csp, 'image.source');
    if (!image)
        return null;
    return (React.createElement("meta", { content: image, itemProp: "image" }));
}
exports.ImageMetaData = ImageMetaData;
function ReviewMetaData(props) {
    var totalReviews = lodash_1.get(props.csp, 'reviews.total');
    if (!totalReviews)
        return null;
    return (React.createElement("div", { itemProp: "aggregateRating", itemScope: true, itemType: "http://schema.org/AggregateRating" },
        React.createElement("meta", { itemProp: "ratingValue", content: props.csp.reviews.avgRating.toString() }),
        React.createElement("meta", { itemProp: "bestRating", content: "5" }),
        React.createElement("meta", { itemProp: "worstRating", content: "1" }),
        React.createElement("meta", { itemProp: "reviewCount", content: totalReviews.toString() })));
}
exports.ReviewMetaData = ReviewMetaData;
function UrlMetaData(props) {
    var url = lodash_1.get(props.csp, 'webLink.href');
    if (!url)
        return null;
    return (React.createElement("meta", { content: url, itemProp: "url" }));
}
exports.UrlMetaData = UrlMetaData;
//# sourceMappingURL=metadata_helper.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/commons/dist/cms/lib/metadata_helper.js
// module id = BSnF
// module chunks = 20 21